import { USER_ROLES } from './acl/user';
import type { ValueOf } from './util/typeUtils';

export const TEAM_CATEGORIES = {
    MARKT: 'MARKT',
    MARKTFOLGE_BANK: 'MARKTFOLGE_BANK',
    MARKTFOLGE_UNTERLAGENBESCHAFFUNG: 'MARKTFOLGE_UNTERLAGENBESCHAFFUNG',
} as const;

export type TEAM_CATEGORY = (typeof TEAM_CATEGORIES)[keyof typeof TEAM_CATEGORIES];

export const IK_PROCESS_STEPS = [
    TEAM_CATEGORIES.MARKT,
    TEAM_CATEGORIES.MARKTFOLGE_BANK,
    TEAM_CATEGORIES.MARKTFOLGE_UNTERLAGENBESCHAFFUNG,
] as const;

export const IK_PROCESS_ERRORS = {
    ALREADY_ASSIGNED: 'IK_PROCESS_ALREADY_ASSIGNED',
    ALREADY_STARTED: 'IK_PROCESS_ALREADY_STARTED',
    CANCELED: 'IK_PROCESS_CANCELED',
    NO_AVAILABLE_USER: 'IK_PROCESS_NO_AVAILABLE_USER',
    NO_NEXT_STEP: 'IK_PROCESS_NO_NEXT_STEP',
} as const;

export type IK_PROCESS_ERROR = ValueOf<typeof IK_PROCESS_ERRORS>;

// the command blocks a restart of the same step this long
export const IK_PROCESS_RESTART_LOCK_MS = 60_000;

export const TEAM_MEMBER_ROLES = [USER_ROLES.adviser] as const;

export type TEAM_MEMBER_ROLE = (typeof TEAM_MEMBER_ROLES)[number];

// only sent to the user routines, which create the team and assign the user as its leader
export const TEAM_LEADER_WITH_TEAM_ASSIGNMENT_KIND = 'teamLeaderWithTeam';
